import React, {
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  TextField,
  MenuItem,
} from '@material-ui/core';

import { emailType } from '@pingum/api-services/EventDataService/EventDataTypes';

export const StatusCommunicationModalComponent = ({
  isOpen,
  eventTemplate,
  workflowStatus,
  handleUpdate,
  onClose,
}) => {
  const [updateWorkflowStatus, setUpdateWorkflowStatus] = useState({ statusCommunication: {} });
  useEffect(() => {
    setUpdateWorkflowStatus(workflowStatus);
  }, [workflowStatus]);

  const handleClose = () => {
    handleUpdate(updateWorkflowStatus);
    onClose();
  };

  const handleChangeStatusCommunication = (e) => {
    const updatedWorkflowStatus = {
      ...workflowStatus,
      statusCommunication: {
        ...updateWorkflowStatus.statusCommunication,
        [e.target.name]: e.target.value,
      },
    };
    setUpdateWorkflowStatus(updatedWorkflowStatus);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="edit-communication-title"
      aria-describedby="edit-communication-description"
      id="edit-communication-dialog"
      maxWidth="md"
    >
      <DialogTitle id="edit-communication-title">Status Communication</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Send an email when the workflow enters this status. Emails are
          sent to emails provided in email custom fields on the
          event/workflow.
        </DialogContentText>

        <TextField
          select
          fullWidth
          margin="normal"
          label="Email Field to Communicate With"
          value={
            updateWorkflowStatus.statusCommunication
              ? updateWorkflowStatus.statusCommunication
                .communicateToEventTemplateId
              : undefined
            }
          name="communicateToEventTemplateId"
          onChange={handleChangeStatusCommunication}
          helperText="Which email custom field should receive the email communication?"
        >
          {
            Object.keys(eventTemplate.eventData).length === 0
              && (
                <MenuItem value={undefined}>
                  No custom field of type Email has been selected for this workflow
                </MenuItem>
              )
          }
          {
            eventTemplate.eventData
              .filter((eventData) => eventData.type === emailType)
              .map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))
          }
        </TextField>
        <TextField
          margin="normal"
          fullWidth
          required
          variant="outlined"
          label="Email Subject"
          value={
            updateWorkflowStatus.statusCommunication
              ? updateWorkflowStatus.statusCommunication.subject
              : ''
            }
          name="subject"
          onChange={handleChangeStatusCommunication}
        />
        <TextField
          margin="normal"
          fullWidth
          required
          variant="outlined"
          label="Email Message"
          multiline
          rows={8}
          value={
            updateWorkflowStatus.statusCommunication
              ? updateWorkflowStatus.statusCommunication.message
              : ''
            }
          name="message"
          onChange={handleChangeStatusCommunication}
        />
        <br /><br />
        <Typography gutterBottom>Data Fields To Include in Email Subject/Message</Typography>
        <Typography variant="caption" component="div" gutterBottom>
          Use any of the below keywords wrapped in {'{{...}}'} to include
          data specific to the workflow/event.
        </Typography>
        <br />
        <Typography variant="caption" gutterBottom component="div">
          <b>Example:</b> <i>Thank you for submitting {'{{workflow_name}}'}</i>
        </Typography>
        <Typography variant="caption" component="div">
          <b>{'{{workflow_name}}'}</b> : Reference the name of the
          workflow/event
        </Typography>
        <Typography variant="caption" component="div">
          <b>{'{{workflow_description}}'}</b> : Reference the description of the
          workflow/event
        </Typography>
        <Typography variant="caption" component="div">
          <b>{'{{workflow_status}}'}</b> : Reference the name of the
          status the workflow/event is in/entered
        </Typography>
        <Typography variant="caption" component="div">
          <b>{'{{event_id}}'}</b> : Reference the ID of the event
          generated from this workflow
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          autoFocus
          id="close-communication-modal"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

StatusCommunicationModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  eventTemplate: PropTypes.object,
  workflowStatus: PropTypes.object,
  handleUpdate: PropTypes.func,
  onClose: PropTypes.func,
};

StatusCommunicationModalComponent.defaultProps = {
  isOpen: false,
  eventTemplate: {},
  workflowStatus: {},
  handleUpdate: () => {},
  onClose: () => {},
};

export default StatusCommunicationModalComponent;
